import React from "react";
import PropTypes from "prop-types";

import Chartkick from "../chartkick_with_extras";

let chartId = 1;

class CustomReactChartkick extends React.Component {
  newChartType(props) {
    const data = props.data;
    const options = {};
    for (const prop in props) {
      if (props.hasOwnProperty(prop) && prop !== "data" && prop !== "id" && prop !== "height" && prop !== "width") {
        options[prop] = props[prop];
      }
    }
    new this.chartType(this.chartId, data, options);
  }

  componentDidMount() {
    this.newChartType(this.props);
  }

  componentDidUpdate(prevProps) {
    const s = JSON.stringify;
    if (s(prevProps.data) !== s(this.props.data)) {
      this.newChartType(this.props);
    }
  }

  render() {
    const props = this.props;
    const style = {
      height: props.height || "300px",
      lineHeight: props.height || "300px",
      width: props.width || "100%",
      textAlign: "center",
      color: "#999",
      fontSize: "14px",
      fontFamily: "'Lucida Grande', 'Lucida Sans Unicode', Verdana, Arial, Helvetica, sans-serif"
    };
    this.chartId = this.chartId || props.id || ("chart-" + chartId++);
    return (
      <div id={this.chartId} style={style}>
        "Loading..."
      </div>
    );
  }
}

CustomReactChartkick.propTypes = {
  data: PropTypes.array
};

const createComponent = function(chartType) {
  const klass = class DynamicReactChartkickChart extends CustomReactChartkick {
    static get name() { return chartType; }

    constructor(props) {
      super(props);

      this.chartType = Chartkick[chartType];
    }
  };

  return klass;
};

export default {
  LineChart: createComponent("LineChart"),
  PieChart: createComponent("PieChart"),
  ColumnChart: createComponent("ColumnChart"),
  BarChart: createComponent("BarChart"),
  AreaChart: createComponent("AreaChart"),
  ScatterChart: createComponent("ScatterChart"),
  GeoChart: createComponent("GeoChart"),
  Timeline: createComponent("Timeline")
};
